<template>
  <div>
    <el-dialog :title="$t('message.orderBindMaterialUsage')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="95%" center append-to-body>
      <el-table v-loading="loading" :data="bindOrderList" :header-cell-style="{ background: '#EDEFF4' }" border>
        <el-table-column :label="$t('message.orderNumber')" align="center" min-width="170">
          <template slot-scope="scope">
            <router-link :to="`/orderPaymentDetail?order_sn=${scope.row.order_sn}`" target="_blank" class="a-link">
              {{ scope.row.order_sn || '-' }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="NO" type="index" align="center" width="70" />
        <el-table-column :label="$t('message.productManagementNumber')" align="center" min-width="150">
          <template slot-scope="scope">{{ scope.row.for_sn || '-' }}</template>
        </el-table-column>
        <el-table-column :label="$t('message.productPicture')" align="center" width="110">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic" :src="scope.row.pic" fit="cover" class="goods-img"
              :preview-src-list="[scope.row.pic]" />
            <div v-else class="empty-img"></div>
          </template>
        </el-table-column>
        <el-table-column label="SKU" align="center" min-width="150">
          <template slot-scope="scope">
            <div class="cell-lines">
              <p v-for="(item, index) in getSku(scope.row)" :key="index">{{ item }}</p>
              <p v-if="!getSku(scope.row).length">-</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.additionalServices')" align="center" min-width="180">
          <template slot-scope="scope">
            <div class="cell-lines">
              <p v-for="(item, index) in getOptions(scope.row)" :key="index">{{ item }}</p>
              <p v-if="!getOptions(scope.row).length">-</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.actualPurchaseQuantity')" align="center" width="120">
          <template slot-scope="scope">{{ scope.row.possible_num }}</template>
        </el-table-column>
        <el-table-column :label="$t('message.shippedQuantity')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.delivery_num }}</template>
        </el-table-column>
        <el-table-column :label="$t('message.estimatedAvailableQuantity')" align="center" width="120">
          <template slot-scope="scope">{{ scope.row.storage_num }}</template>
        </el-table-column>
        <el-table-column :label="$t('message.consumptionPerSet')" align="center" width="130">
          <template slot-scope="scope">{{ scope.row.consume }} {{ $t('message.pointsPerSet') }}</template>
        </el-table-column>
        <el-table-column :label="$t('message.estimatedConsumptionPoints')" align="center" width="140">
          <template slot-scope="scope">{{ scope.row.consume * scope.row.possible_num }}</template>
        </el-table-column>
        <el-table-column :label="$t('message.operation')" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="unbindMaterial(scope.row)">{{ $t('message.unbindMaterial') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-row">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageForm.page" :page-sizes="[10, 20, 50]" :page-size="pageForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BindOrderUsage',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      material: {},
      bindOrderList: [],
      total: 0,
      pageForm: {
        page: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    open(material) {
      this.material = material || {}
      this.pageForm = {
        page: 1,
        pageSize: 10
      }
      this.dialogVisible = true
      this.bindOrderDetailList()
    },
    bindOrderDetailList() {
      const datas = {
        id: this.material.id,
        page: this.pageForm.page,
        pageSize: this.pageForm.pageSize
      }
      if (!datas.id) return
      this.loading = true
      this.$api.warehouseApi.bindOrderDetailList(datas).then(res => {
        const data = res.data || {}
        this.bindOrderList = data.data || []
        this.total = data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    unbindMaterial(row) {
      this.$confirm(this.$t('message.confirmUnbindMaterial'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning'
      }).then(() => {
        const orderDetailId = row.order_detail_id || row.id
        const datas = {
          user_id: this.material.user_id || '',
          list: {
            [orderDetailId]: [this.material.id]
          }
        }
        this.$api.warehouseApi.sortingUnbindMaterial(datas).then(res => {
          this.$message.success(res.msg)
          this.bindOrderDetailList()
          this.$emit('saved')
        })
      }).catch(() => { })
    },
    getSku(row) {
      const detail = row.detail_y && row.detail_y.length ? row.detail_y : row.detail
      if (!detail || !detail.length) return []
      return detail.map(item => `${item.key || ''}${item.value ? '：' + item.value : ''}`)
    },
    getOptions(row) {
      if (!row.option || !row.option.length) return []
      return row.option.map(item => {
        const num = item.num ? `*${item.num}` : ''
        const price = item.price ? ` ${item.price}${item.unit || ''}` : ''
        return `${item.name || ''}${num}${price}`
      })
    },
    handleCurrentChange(val) {
      this.pageForm.page = val
      this.bindOrderDetailList()
    },
    handleSizeChange(val) {
      this.pageForm.pageSize = val
      this.pageForm.page = 1
      this.bindOrderDetailList()
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-img,
.empty-img {
  width: 60px;
  height: 60px;
  background: #d8d8d8;
}

.cell-lines {
  max-height: 90px;
  overflow: hidden;
  line-height: 20px;

  p {
    margin: 0;
  }
}

.a-link {
  color: #2c96e7;
}

.pagination-row {
  margin-top: 16px;
  text-align: center;
}
</style>
